import { render } from "./Books.vue?vue&type=template&id=2abcd04d&scoped=true"
import script from "./Books.vue?vue&type=script&lang=js"
export * from "./Books.vue?vue&type=script&lang=js"

import "./Books.vue?vue&type=style&index=0&id=2abcd04d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2abcd04d"

export default script